import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { HeadersDataInterface } from 'src/_lib/interfaces/header.interface';
import { CommunicationService } from 'src/_lib/service/communication.service';
import { HeaderService } from 'src/_lib/service/header.service';
import { AppConstants } from 'src/app/app.constants';
import { environment } from 'src/environments/environment.prod';
import { OffcanvasService } from 'src/_lib/service/offcanvasslide.service';
import { BrowserService } from 'src/_lib/service/browser.service';
@Component({
  selector: 'app-header-cart-section',
  templateUrl: './header-cart-section.component.html',
  styleUrls: ['./header-cart-section.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink],
})
export class HeaderCartSectionComponent implements OnInit, OnDestroy {
  cartItems: number = null;
  wishItems: number;
  firstObj: number = this.appConstants.firstObj;
  cdnImagePath: string = environment.cdnImagePath;
  private hideTimeout: any;
  headerdata: HeadersDataInterface = {
    websiteHeader: [],
    firstRow: [],
    secondRow: [],
    thirdRow: []
  };
  
  @Input() isMobile: boolean = false;
  @Input() showdowntooltip: boolean = false;
  username: string | null = null;
  tooltipVisible: boolean = false;
  private subs = new Subscription();

  constructor(
    private headerHttp: HeaderService,
    private appConstants: AppConstants,
    private comm: CommunicationService,
    private router: Router,
    private offcanvasService: OffcanvasService,
    private browser: BrowserService
  ) { }

  ngOnInit(): void {
    this.comm.username$.subscribe(name => {
      if (name) {
        this.getLoggedInUserName();
      } else {
        this.username = null;
      }
    });
    this.comm.cacheClear.subscribe(()=>{
      this.getWishItems();
      this.getheaderList();
      this.getOrderItems();
      this.getLoggedInUserName();
    })
  }

  getheaderList(): void {
    this.headerHttp.headerList().subscribe((data) => {
      this.headerdata = data[this.firstObj]?.data?.secondRow;
    });
  }

  goToLogin() {
    const currentUrl = this.router.url;
    this.browser.localStorage?.setItem('redirectAfterLogin', currentUrl);
    this.router.navigate(['/customer-login']);
  }

  getWishItems(): void {
    this.wishItems = +this.browser.localStorage?.getItem('wishlistItem') || 0;
    this.comm.wishlistCount.subscribe((value) => {
      this.wishItems = +this.browser.localStorage?.getItem('wishlistItem') || 0;
    });
  }

  getOrderItems(): void {
    const previousItemCount = this.cartItems;
    this.cartItems = +this.browser.localStorage?.getItem('ItemCount') || 0;
    if (
      this.browser.localStorage?.getItem('ItemRecentlyAdded') &&
      this.cartItems > previousItemCount
    ) {
      this.browser.localStorage?.removeItem('ItemRecentlyAdded');
    }
    this.comm.itemCount.subscribe(() => {
      const newItemCount = +this.browser.localStorage?.getItem('ItemCount') || 0;
      if (
        this.browser.localStorage?.getItem('ItemRecentlyAdded') &&
        newItemCount > this.cartItems
      ) {
        this.browser.localStorage?.removeItem('ItemRecentlyAdded');
      }
      this.cartItems = newItemCount;
    });
  }

  hideTooltip(): void {
    this.hideTimeout = setTimeout(() => {
      this.tooltipVisible = false;
    }, 200);
  }

  showTooltip(): void {
    clearTimeout(this.hideTimeout);
    if (this.username) {
      this.tooltipVisible = true;
    }
  }

  getLoggedInUserName(): string | null {
    this.username = this.browser.localStorage?.getItem('Username');
    return this.username;
  }

  onAccountButton(): void {
    const user = this.getLoggedInUserName();
    if (user) {
      this.openAccountOffcanvas()
    } else {
      this.goToLogin();
    }
  }

  openCartOffcanvas() {
    this.browser.window?.dispatchEvent(new Event('open-shopping-cart'));
    setTimeout(() => {
      this.offcanvasService.open('shoppingCartOffcanvas');
    }, 50);
  }

  openAccountOffcanvas() {
    this.browser.window?.dispatchEvent(new Event('open-account-popup'));
    setTimeout(() => {
      this.offcanvasService.open('myAccountOffcanvas');
    }, 50);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}